// Extended mock data for HR-AI Use Cases

export const trustedCompanies = [
  { id: 1, name: 'VDAB' },
  { id: 2, name: 'Colruyt Group' },
  { id: 3, name: 'Brussels Airport' },
  { id: 4, name: 'De Lijn' },
  { id: 5, name: 'Equans Belux' },
  { id: 6, name: 'Euroclear' },
  { id: 7, name: 'Mondelez' },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah De Vries',
    role: 'HR Director, Tech Scale-up',
    initial: 'S',
    photo: 'https://images.unsplash.com/photo-1655249481446-25d575f1c054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwaGVhZHNob3QlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NjgwMjE0MDd8MA&ixlib=rb-4.1.0&q=85&w=200',
    quote: 'The quickscan gave us immediate clarity on where to start. We implemented CV screening in 2 weeks and reduced time-to-hire by 60%. The workshop was incredibly practical.',
  },
  {
    id: 2,
    name: 'Marc Janssens',
    role: 'Head of L&D, Manufacturing',
    initial: 'M',
    photo: 'https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1hbiUyMGhlYWRzaG90JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzY4MDIxNDA5fDA&ixlib=rb-4.1.0&q=85&w=200',
    quote: "Finally, a no-nonsense approach to AI in HR. The benchmark data opened our eyes, and the workshop delivered exactly what we needed: a working prototype and clear roadmap.",
  },
  {
    id: 3,
    name: 'Lisa Peeters',
    role: 'CHRO, Financial Services',
    initial: 'L',
    photo: 'https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdvbWFuJTIwaGVhZHNob3QlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NjgwMjE0MDd8MA&ixlib=rb-4.1.0&q=85&w=200',
    quote: "We went from 'AI is scary' to having two working use cases in one month. Dominique's expertise and hands-on approach made all the difference. Highly recommended!",
  },
];

export const useCasesDetailed = [
  {
    id: 1,
    title: 'AI-Powered CV Screening',
    description: 'Automatic screening of CVs based on job requirements, focusing on skills and experience. Reduces screening time by 80% and improves match quality.',
    shortDescription: 'Automatic screening of CVs based on job requirements, focusing on skills and experience.',
    category: 'quick-wins',
    domain: 'recruitment',
    domainLabel: 'Recruitment',
    difficulty: 'low',
    impact: 'high',
    implTime: '4w',
    cost: 'Low Cost',
    costRange: '€5,000 - 15,000',
    skills: 3,
    votes: 42,
    implementationSteps: [
      'Define must-have and nice-to-have criteria',
      'Train model on historical successful hires',
      'Implement in ATS workflow',
      'Monitor and refine matching criteria',
    ],
    requiredSkills: [
      'Basic AI understanding',
      'ATS knowledge',
      'Recruitment expertise',
    ],
    tools: ['HireVue', 'Pymetrics', 'Ideal', 'SeekOut'],
    hoursSaved: 520,
    roiFormula: 'employees * 2_questions_per_month * 15_minutes * hourly_rate',
    roiVariables: [
      { key: 'vacancies_per_year', label: 'Vacatures per jaar', default: 50, min: 0, max: 500, step: 1, unit: '', tooltip: 'Totaal aantal openstaande vacatures dat u jaarlijks invult. Inclusief vervanging en groei. Tel ook interne mobiliteit mee indien apart geworven.' },
      { key: 'cvs_per_vacancy', label: "CV's per vacature", default: 80, min: 0, max: 500, step: 1, unit: '', tooltip: "Gemiddeld aantal ontvangen CV's per vacature. Afhankelijk van: functieniveau (junior=meer, senior=minder), arbeidsmarkt, employer brand. Benchmark: 50-100 voor reguliere functies, 150+ voor populaire starters-rollen." },
      { key: 'screening_time_minutes', label: 'Screening tijd per CV (min)', default: 8, min: 0, max: 30, step: 1, unit: 'min', tooltip: 'Totale tijd per CV inclusief: openen/downloaden, doorlezen, beoordelen tegen criteria, notities maken, beslissing nemen, kandidaat afwijzen of doorsturen. Inclusief administratieve handelingen in ATS.' },
      { key: 'hourly_rate', label: 'Uurtarief recruiter (€)', default: 45, min: 0, max: 150, step: 1, unit: '€', tooltip: 'Volledig belast uurtarief recruiter. Bereken: bruto uurloon × 1.3-1.4 (werkgeverslasten). Inclusief sociale lasten, vakantiegeld, pensioen, tooling en overhead. Senior recruiters: €60-80, medior: €40-55, junior: €25-40.' },
      { key: 'time_reduction_percent', label: 'Tijdsbesparing door AI (%)', default: 80, min: 0, max: 95, step: 1, unit: '%', tooltip: 'Percentage tijdsbesparing door AI-screening. Conservatief: 60-70%, realistisch: 75-85%, optimaal (na training): 85-95%. Afhankelijk van CV-kwaliteit en modeltraining.' },
    ],
    roiCalculation: (vars) => {
      const totalCVs = vars.vacancies_per_year * vars.cvs_per_vacancy;
      const currentHours = (totalCVs * vars.screening_time_minutes) / 60;
      const savedHours = currentHours * (vars.time_reduction_percent / 100);
      const savings = savedHours * vars.hourly_rate;
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: "Totaal CV's per jaar", value: vars.vacancies_per_year * vars.cvs_per_vacancy },
      { label: 'Huidige screening uren', value: Math.round((vars.vacancies_per_year * vars.cvs_per_vacancy * vars.screening_time_minutes) / 60) },
      { label: 'Besparing percentage', value: `${vars.time_reduction_percent}%` },
    ],
  },
  {
    id: 2,
    title: 'HR FAQ Chatbot',
    description: 'Intelligent chatbot that answers 80% of standard HR questions (leave, payslip, policies). Available 24/7, reducing HR workload significantly.',
    shortDescription: 'Intelligent chatbot that answers 80% of standard HR questions (leave, payslip, policies). Available 24/7.',
    category: 'quick-wins',
    domain: 'hr-operations',
    domainLabel: 'HR Operations',
    difficulty: 'low',
    impact: 'medium',
    implTime: '6w',
    cost: 'Low Cost',
    costRange: '€5,000 - 15,000',
    skills: 3,
    votes: 39,
    implementationSteps: [
      'Collect and categorize common HR questions',
      'Build knowledge base from policies and documents',
      'Configure chatbot platform and train model',
      'Integrate with internal communication tools',
    ],
    requiredSkills: [
      'HR policy knowledge',
      'Content management',
      'Basic chatbot configuration',
    ],
    tools: ['Microsoft Copilot', 'Moveworks', 'Leena AI', 'ServiceNow'],
    hoursSaved: 520,
    roiFormula: 'employees * questions_per_year * time_per_question * hourly_rate * automation_rate',
    roiVariables: [
      { key: 'employees', label: 'Aantal medewerkers', default: 500, min: 0, max: 15000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers in uw organisatie dat potentieel HR-vragen kan stellen. Inclusief voltijd, deeltijd en tijdelijke medewerkers.' },
      { key: 'questions_per_year', label: 'HR-vragen per medewerker/jaar', default: 1, min: 0, max: 30, step: 1, unit: '', tooltip: 'Gemiddeld aantal HR-gerelateerde vragen per medewerker per jaar. Benchmark: 6-12 voor stabiele organisaties, 15-25 voor groeiende/veranderende organisaties, 25+ bij reorganisaties of beleidswijzigingen.' },
      { key: 'time_per_question', label: 'Tijd per vraag (min)', default: 15, min: 0, max: 45, step: 1, unit: 'min', tooltip: 'Gemiddelde tijd die HR besteedt per vraag. Inclusief: vraag lezen/begrijpen, informatie opzoeken, antwoord formuleren, eventuele follow-up. Eenvoudige vragen: 5-10 min, gemiddeld: 15 min, complex: 30+ min.' },
      { key: 'hourly_rate', label: 'Uurtarief HR medewerker (€)', default: 40, min: 0, max: 100, step: 1, unit: '€', tooltip: 'Volledig belast uurtarief van HR medewerker. Bereken: bruto uurloon × 1.3-1.4 (werkgeverslasten). Inclusief sociale lasten, vakantiegeld, pensioen en overhead.' },
      { key: 'automation_rate', label: 'Automatiseringsgraad (%)', default: 80, min: 0, max: 95, step: 1, unit: '%', tooltip: 'Percentage vragen dat de chatbot zelfstandig kan afhandelen. Benchmark: 60-70% bij start, 75-85% na 6 maanden optimalisatie, 85-95% na 1+ jaar met continue verbetering.' },
    ],
    roiCalculation: (vars) => {
      const totalQuestions = vars.employees * vars.questions_per_year;
      const currentHours = (totalQuestions * vars.time_per_question) / 60;
      const savedHours = currentHours * (vars.automation_rate / 100);
      const savings = savedHours * vars.hourly_rate;
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'HR-vragen per jaar', value: vars.employees * vars.questions_per_year },
      { label: 'Huidige afhandeltijd (uren)', value: Math.round((vars.employees * vars.questions_per_year * vars.time_per_question) / 60) },
      { label: 'Geautomatiseerd', value: `${vars.automation_rate}%` },
    ],
  },
  {
    id: 3,
    title: 'Predictive Attrition Analysis',
    description: 'Predict which employees are at risk of leaving, enabling proactive retention actions. Identifies early warning signs based on multiple data points.',
    shortDescription: 'Predict which employees are at risk of leaving, enabling proactive retention actions. Identifies earl...',
    category: 'strategic',
    domain: 'talent',
    domainLabel: 'Talent Management',
    difficulty: 'medium',
    impact: 'high',
    implTime: '12w',
    cost: 'Medium Cost',
    costRange: '€15,000 - 40,000',
    skills: 4,
    votes: 36,
    implementationSteps: [
      'Identify relevant data sources (HRIS, surveys, etc.)',
      'Build predictive model with historical data',
      'Create dashboard for HR and managers',
      'Develop intervention playbooks',
    ],
    requiredSkills: [
      'Data analytics',
      'HR metrics knowledge',
      'Change management',
      'Statistical modeling',
    ],
    tools: ['Visier', 'One Model', 'Workday Prism', 'Crunchr'],
    hoursSaved: 800,
    roiFormula: 'prevented_turnover * cost_per_hire + productivity_impact',
    roiVariables: [
      { key: 'employees', label: 'Aantal medewerkers', default: 500, min: 0, max: 10000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers in scope voor verloopanalyse. Focus op vaste en langdurige contracten waar retentie relevant is.' },
      { key: 'turnover_rate', label: 'Huidig verloop (%)', default: 15, min: 0, max: 40, step: 1, unit: '%', tooltip: 'Jaarlijks vrijwillig verlooppercentage. Benchmark per sector: Tech 15-25%, Finance 10-15%, Retail/Horeca 30-50%, Healthcare 15-20%. Exclusief pensioen en reorganisaties.' },
      { key: 'avg_salary', label: 'Gemiddeld jaarsalaris (€)', default: 55000, min: 0, max: 150000, step: 1, unit: '€', tooltip: 'Gemiddeld bruto jaarsalaris van medewerkers in scope. Inclusief vakantiegeld en eventuele bonussen. Gebruik HR-data voor nauwkeurige cijfers.' },
      { key: 'cost_per_hire_factor', label: 'Kosten per hire (% salaris)', default: 30, min: 0, max: 100, step: 1, unit: '%', tooltip: 'Totale vervangingskosten als percentage van jaarsalaris. Inclusief: werving, selectie, onboarding, productiviteitsverlies, training. Benchmark: 30-50% voor reguliere functies, 100%+ voor specialisten/management.' },
      { key: 'prevention_rate', label: 'Voorkomen verloop door AI (%)', default: 20, min: 0, max: 40, step: 1, unit: '%', tooltip: 'Percentage van voorspeld verloop dat daadwerkelijk voorkomen kan worden door tijdige interventie. Conservatief: 10-15%, realistisch: 15-25%, optimaal: 25-40%. Afhankelijk van managementcommitment.' },
    ],
    roiCalculation: (vars) => {
      const annualTurnover = vars.employees * (vars.turnover_rate / 100);
      const costPerHire = vars.avg_salary * (vars.cost_per_hire_factor / 100);
      const preventedTurnover = annualTurnover * (vars.prevention_rate / 100);
      const savings = preventedTurnover * costPerHire;
      const savedHours = preventedTurnover * 40; // Estimated hours per prevented departure
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Jaarlijks verloop (personen)', value: Math.round(vars.employees * (vars.turnover_rate / 100)) },
      { label: 'Kosten per vervanging', value: `€${Math.round(vars.avg_salary * (vars.cost_per_hire_factor / 100)).toLocaleString()}` },
      { label: 'Voorkomen vertrekken', value: Math.round(vars.employees * (vars.turnover_rate / 100) * (vars.prevention_rate / 100)) },
    ],
  },
  {
    id: 4,
    title: 'Pre & Onboarding Chatbot',
    description: 'AI-driven personalized pre-boarding and onboarding paths that adapt to role, department, and individual learning pace. Increases new hire productivity by 40%.',
    shortDescription: 'AI-driven personalized pre-boarding and onboarding paths that adapt to role, department, and individual learning pace.',
    category: 'foundational',
    domain: 'onboarding',
    domainLabel: 'Onboarding',
    difficulty: 'medium',
    impact: 'medium',
    implTime: '8w',
    cost: 'Medium Cost',
    costRange: '€10,000 - 25,000',
    skills: 3,
    votes: 31,
    implementationSteps: [
      'Map current pre-boarding and onboarding processes per role',
      'Create modular learning content',
      'Configure AI-driven path selection',
      'Set up progress tracking and feedback loops',
    ],
    requiredSkills: [
      'L&D expertise',
      'Content creation',
      'LMS administration',
    ],
    tools: ['Enboarder', 'Talmundo', 'Click Boarding', 'Sapling'],
    hoursSaved: 300,
    roiFormula: 'new_hires_per_year * hours_saved_per_hire * hourly_rate',
    roiVariables: [
      { key: 'new_hires_per_year', label: 'Nieuwe medewerkers per jaar', default: 50, min: 0, max: 2000, step: 1, unit: '', tooltip: 'Jaarlijks aantal nieuwe medewerkers dat onboarding doorloopt. Inclusief externe hires en interne mobiliteit indien apart onboarding nodig.' },
      { key: 'onboarding_hours_current', label: 'Huidige onboarding uren (HR)', default: 20, min: 0, max: 60, step: 1, unit: 'uur', tooltip: 'HR-tijd per nieuwe medewerker voor onboarding. Inclusief: administratie, systemen, introductiegesprekken, vragen beantwoorden, compliance checks. Exclusief buddy/mentor tijd.' },
      { key: 'hourly_rate_hr', label: 'Uurtarief HR (€)', default: 40, min: 0, max: 100, step: 1, unit: '€', tooltip: 'Volledig belast uurtarief HR medewerker betrokken bij onboarding. Bereken: bruto × 1.3-1.4 voor werkgeverslasten en overhead.' },
      { key: 'time_reduction', label: 'Tijdsbesparing HR (%)', default: 50, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Percentage HR-tijd dat bespaard wordt door automatisering. Conservatief: 30-40%, realistisch: 45-60%, optimaal: 60-80%. Afhankelijk van huidige digitalisatiegraad.' },
      { key: 'productivity_gain_weeks', label: 'Sneller productief (weken)', default: 2, min: 0, max: 8, step: 1, unit: 'weken', tooltip: 'Aantal weken eerder dat nieuwe medewerkers volledig productief zijn door betere onboarding. Benchmark: 1-2 weken voor eenvoudige rollen, 3-4 voor kenniswerkers, 6-8 voor complexe specialisaties.' },
      { key: 'avg_weekly_value', label: 'Gem. waarde nieuwe hire/week (€)', default: 1500, min: 0, max: 5000, step: 1, unit: '€', tooltip: 'Gemiddelde economische waarde die een volledig productieve medewerker per week genereert. Bereken: jaarsalaris / 45 weken × productiviteitsfactor (1.5-3x afhankelijk van rol).' },
    ],
    roiCalculation: (vars) => {
      const hrSavings = vars.new_hires_per_year * vars.onboarding_hours_current * (vars.time_reduction / 100) * vars.hourly_rate_hr;
      const productivityGain = vars.new_hires_per_year * vars.productivity_gain_weeks * vars.avg_weekly_value * 0.4; // 40% productivity improvement
      const savings = hrSavings + productivityGain;
      const savedHours = vars.new_hires_per_year * vars.onboarding_hours_current * (vars.time_reduction / 100);
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'HR uren bespaard', value: Math.round(vars.new_hires_per_year * vars.onboarding_hours_current * (vars.time_reduction / 100)) },
      { label: 'HR kostenbesparing', value: `€${Math.round(vars.new_hires_per_year * vars.onboarding_hours_current * (vars.time_reduction / 100) * vars.hourly_rate_hr).toLocaleString()}` },
      { label: 'Productiviteitswinst', value: `€${Math.round(vars.new_hires_per_year * vars.productivity_gain_weeks * vars.avg_weekly_value * 0.4).toLocaleString()}` },
    ],
  },
  {
    id: 5,
    title: 'Skills Gap Analysis',
    description: 'AI-powered analysis of current vs required skills across the organization. Identifies development priorities and future skill needs.',
    shortDescription: 'AI-powered analysis of current vs required skills across the organization.',
    category: 'strategic',
    domain: 'learning',
    domainLabel: 'Learning & Development',
    difficulty: 'medium',
    impact: 'high',
    implTime: '10w',
    cost: 'Medium Cost',
    costRange: '€15,000 - 35,000',
    skills: 4,
    votes: 38,
    implementationSteps: [
      'Define skill taxonomy and framework',
      'Assess current skills through AI analysis',
      'Map future skill requirements',
      'Generate personalized development plans',
    ],
    requiredSkills: [
      'Skills framework knowledge',
      'L&D strategy',
      'Data analysis',
      'Workforce planning',
    ],
    tools: ['Degreed', 'Gloat', 'Eightfold', 'Beamery'],
    hoursSaved: 600,
    roiFormula: 'avoided_external_hires * recruitment_cost + training_efficiency',
    roiVariables: [
      { key: 'employees', label: 'Aantal medewerkers', default: 500, min: 0, max: 10000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers waarvoor skills geanalyseerd worden. Typisch alle vaste medewerkers in kennisintensieve functies.' },
      { key: 'external_hires_year', label: 'Externe hires per jaar', default: 30, min: 0, max: 200, step: 1, unit: '', tooltip: 'Aantal posities dat extern ingevuld wordt. Hoe hoger, hoe meer potentieel voor interne mobiliteit en dus kostenbesparing.' },
      { key: 'avg_recruitment_cost', label: 'Gem. recruitment kosten (€)', default: 15000, min: 0, max: 50000, step: 1, unit: '€', tooltip: 'Totale kosten per externe hire. Inclusief: vacaturetekst, sourcing, bureau fees (indien van toepassing), tijd selectieproces, onboarding. Benchmark: €10-20K regulier, €25-50K specialist/management.' },
      { key: 'internal_fill_improvement', label: 'Verbetering interne invulling (%)', default: 25, min: 0, max: 50, step: 1, unit: '%', tooltip: 'Verwachte toename van intern ingevulde vacatures door betere skills-matching. Conservatief: 15-20%, realistisch: 20-30%, optimaal: 30-50%.' },
      { key: 'training_budget', label: 'Jaarlijks trainingsbudget (€)', default: 200000, min: 0, max: 2000000, step: 1, unit: '€', tooltip: 'Totaal L&D budget voor trainingen, cursussen, certificeringen. Skills gap analyse helpt dit budget gerichter in te zetten.' },
      { key: 'training_efficiency_gain', label: 'Efficiëntie trainingsbudget (%)', default: 15, min: 0, max: 30, step: 1, unit: '%', tooltip: 'Verbetering in training-ROI door gerichte investeringen op basis van skills gap data. Minder verspilling aan irrelevante trainingen.' },
    ],
    roiCalculation: (vars) => {
      const avoidedExternalHires = vars.external_hires_year * (vars.internal_fill_improvement / 100);
      const recruitmentSavings = avoidedExternalHires * vars.avg_recruitment_cost;
      const trainingSavings = vars.training_budget * (vars.training_efficiency_gain / 100);
      const savings = recruitmentSavings + trainingSavings;
      const savedHours = avoidedExternalHires * 40 + (trainingSavings / 50); // Estimated
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Vermeden externe hires', value: Math.round(vars.external_hires_year * (vars.internal_fill_improvement / 100)) },
      { label: 'Recruitment besparing', value: `€${Math.round(vars.external_hires_year * (vars.internal_fill_improvement / 100) * vars.avg_recruitment_cost).toLocaleString()}` },
      { label: 'Training efficiëntie winst', value: `€${Math.round(vars.training_budget * (vars.training_efficiency_gain / 100)).toLocaleString()}` },
    ],
  },
  {
    id: 6,
    title: 'Performance Review Summarizer',
    description: 'NLP tool to analyze and summarize performance review feedback, identifying patterns and development themes automatically.',
    shortDescription: 'NLP tool to analyze and summarize performance review feedback.',
    category: 'quick-wins',
    domain: 'performance',
    domainLabel: 'Performance',
    difficulty: 'low',
    impact: 'medium',
    implTime: '4w',
    cost: 'Low Cost',
    costRange: '€5,000 - 12,000',
    skills: 2,
    votes: 27,
    implementationSteps: [
      'Connect to performance management system',
      'Configure NLP model for HR context',
      'Set up summary templates and themes',
      'Train HR on interpretation and usage',
    ],
    requiredSkills: [
      'Performance management expertise',
      'Basic NLP understanding',
    ],
    tools: ['Culture Amp', 'Lattice', 'Textio', '15Five'],
    hoursSaved: 200,
    roiFormula: 'managers * time_per_review * number_of_reviews * hourly_rate',
    roiVariables: [
      { key: 'managers', label: 'Aantal managers', default: 50, min: 0, max: 500, step: 1, unit: '', tooltip: 'Totaal aantal managers dat performance reviews uitvoert. Inclusief team leads, middle management en senior management.' },
      { key: 'direct_reports_avg', label: 'Gem. directe reports per manager', default: 8, min: 0, max: 20, step: 1, unit: '', tooltip: 'Gemiddeld aantal directe medewerkers per manager. Span of control varieert: operations 10-15, kenniswerk 5-8, specialisten 3-5.' },
      { key: 'reviews_per_year', label: 'Reviews per medewerker/jaar', default: 2, min: 0, max: 4, step: 1, unit: '', tooltip: 'Aantal formele performance reviews per jaar. Trend: van 1-2 jaarlijks naar continu feedback met kwartaal check-ins.' },
      { key: 'time_per_review', label: 'Tijd per review (min)', default: 45, min: 0, max: 120, step: 1, unit: 'min', tooltip: 'Totale managertijd per review. Inclusief: voorbereiding, feedback verzamelen, formulier invullen, gesprek, follow-up notities. Excl. het gesprek zelf.' },
      { key: 'hourly_rate_manager', label: 'Uurtarief manager (€)', default: 75, min: 0, max: 200, step: 1, unit: '€', tooltip: 'Volledig belast uurtarief manager. Bereken: bruto × 1.3-1.4. Management: €60-100, senior management: €100-150+.' },
      { key: 'time_reduction', label: 'Tijdsbesparing door AI (%)', default: 60, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Tijdsbesparing door automatische samenvattingen en patroonherkenning. AI analyseert feedback en identificeert themas automatisch.' },
    ],
    roiCalculation: (vars) => {
      const totalReviews = vars.managers * vars.direct_reports_avg * vars.reviews_per_year;
      const currentHours = (totalReviews * vars.time_per_review) / 60;
      const savedHours = currentHours * (vars.time_reduction / 100);
      const savings = savedHours * vars.hourly_rate_manager;
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Totaal reviews per jaar', value: vars.managers * vars.direct_reports_avg * vars.reviews_per_year },
      { label: 'Huidige reviewtijd (uren)', value: Math.round((vars.managers * vars.direct_reports_avg * vars.reviews_per_year * vars.time_per_review) / 60) },
      { label: 'Tijdsbesparing', value: `${vars.time_reduction}%` },
    ],
  },
  {
    id: 7,
    title: 'Interview Intelligence',
    description: 'AI-powered interview analysis providing real-time suggestions, bias detection, and structured feedback to improve hiring decisions.',
    shortDescription: 'AI-powered interview analysis providing real-time suggestions and bias detection.',
    category: 'strategic',
    domain: 'recruitment',
    domainLabel: 'Recruitment',
    difficulty: 'high',
    impact: 'high',
    implTime: '12w',
    cost: 'High Cost',
    costRange: '€30,000 - 60,000',
    skills: 4,
    votes: 33,
    implementationSteps: [
      'Select and configure interview intelligence platform',
      'Define structured interview frameworks',
      'Train interviewers on AI-assisted process',
      'Monitor and refine bias detection algorithms',
    ],
    requiredSkills: [
      'Recruitment expertise',
      'Interview design',
      'AI ethics knowledge',
      'Change management',
    ],
    tools: ['BrightHire', 'Metaview', 'Pillar', 'HireLogic'],
    hoursSaved: 400,
    roiFormula: 'interviews_per_year * time_saved * hourly_rate + quality_improvement',
    roiVariables: [
      { key: 'interviews_per_year', label: 'Interviews per jaar', default: 500, min: 0, max: 5000, step: 1, unit: '', tooltip: 'Totaal aantal sollicitatiegesprekken per jaar. Tel alle rondes mee: screening calls, eerste gesprekken, vervolggesprekken, panel interviews.' },
      { key: 'interviewers_per_interview', label: 'Interviewers per gesprek', default: 2, min: 0, max: 5, step: 1, unit: '', tooltip: 'Gemiddeld aantal interviewers per gesprek. 1-2 voor eerste ronde, 2-3 voor vervolg, 3-5 voor panel/assessment.' },
      { key: 'debrief_time', label: 'Nabespreking tijd (min)', default: 30, min: 0, max: 60, step: 1, unit: 'min', tooltip: 'Tijd voor nabespreking en feedback documenteren na elk gesprek. Inclusief scorecards invullen, afstemming met collega-interviewers.' },
      { key: 'hourly_rate', label: 'Gem. uurtarief interviewer (€)', default: 60, min: 0, max: 150, step: 1, unit: '€', tooltip: 'Gewogen gemiddeld uurtarief van alle interviewers. Mix van recruiters, hiring managers en executives.' },
      { key: 'time_reduction', label: 'Tijdsbesparing (%)', default: 50, min: 0, max: 70, step: 1, unit: '%', tooltip: 'Besparing op nabespreking door automatische transcriptie, samenvatting en gestructureerde feedback. AI genereert candidate profiles automatisch.' },
      { key: 'bad_hire_reduction', label: 'Vermindering slechte hires (%)', default: 20, min: 0, max: 40, step: 1, unit: '%', tooltip: 'Reductie in mis-hires door consistentere evaluatie en bias-detectie. Gestructureerde interviews en objectieve scoring verbeteren kwaliteit.' },
      { key: 'cost_bad_hire', label: 'Kosten slechte hire (€)', default: 25000, min: 0, max: 100000, step: 1, unit: '€', tooltip: 'Totale kosten van een verkeerde hire. Inclusief: salaris tijdens proeftijd, re-recruitment, productiviteitsverlies team, onboarding verspild. Vuistregel: 0.5-2x jaarsalaris.' },
      { key: 'bad_hires_year', label: 'Slechte hires per jaar', default: 5, min: 0, max: 30, step: 1, unit: '', tooltip: 'Geschat aantal hires dat binnen 1 jaar vertrekt of onvoldoende presteert. Benchmark: 10-20% van alle hires is een mis-hire.' },
    ],
    roiCalculation: (vars) => {
      const debriefHours = (vars.interviews_per_year * vars.interviewers_per_interview * vars.debrief_time) / 60;
      const timeSavings = debriefHours * (vars.time_reduction / 100) * vars.hourly_rate;
      const qualitySavings = vars.bad_hires_year * (vars.bad_hire_reduction / 100) * vars.cost_bad_hire;
      const savings = timeSavings + qualitySavings;
      const savedHours = debriefHours * (vars.time_reduction / 100);
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Nabespreking uren/jaar', value: Math.round((vars.interviews_per_year * vars.interviewers_per_interview * vars.debrief_time) / 60) },
      { label: 'Tijdsbesparing', value: `€${Math.round((vars.interviews_per_year * vars.interviewers_per_interview * vars.debrief_time / 60) * (vars.time_reduction / 100) * vars.hourly_rate).toLocaleString()}` },
      { label: 'Kwaliteitsverbetering', value: `€${Math.round(vars.bad_hires_year * (vars.bad_hire_reduction / 100) * vars.cost_bad_hire).toLocaleString()}` },
    ],
  },
  {
    id: 8,
    title: 'Employee Sentiment Analysis',
    description: 'Continuous pulse surveys analyzed by AI to detect engagement trends, concerns, and opportunities before they become issues.',
    shortDescription: 'Continuous pulse surveys analyzed by AI to detect engagement trends and concerns.',
    category: 'foundational',
    domain: 'wellbeing',
    domainLabel: 'Wellbeing',
    difficulty: 'medium',
    impact: 'medium',
    implTime: '6w',
    cost: 'Medium Cost',
    costRange: '€10,000 - 25,000',
    skills: 3,
    votes: 29,
    implementationSteps: [
      'Design pulse survey framework',
      'Configure sentiment analysis engine',
      'Set up real-time dashboards',
      'Create action playbooks per sentiment pattern',
    ],
    requiredSkills: [
      'Employee engagement expertise',
      'Survey design',
      'Data visualization',
    ],
    tools: ['Peakon', 'Glint', 'Qualtrics', 'Officevibe'],
    hoursSaved: 350,
    roiFormula: 'engagement_improvement * productivity_gain + reduced_turnover',
    roiVariables: [
      { key: 'employees', label: 'Aantal medewerkers', default: 500, min: 0, max: 10000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers dat pulse surveys ontvangt. Typisch alle vaste medewerkers.' },
      { key: 'avg_salary', label: 'Gemiddeld jaarsalaris (€)', default: 50000, min: 0, max: 150000, step: 1, unit: '€', tooltip: 'Gemiddeld bruto jaarsalaris. Gebruikt voor berekening productiviteitswinst door verbeterde engagement.' },
      { key: 'engagement_improvement', label: 'Engagement verbetering (%)', default: 10, min: 0, max: 25, step: 1, unit: '%', tooltip: 'Verwachte verbetering in engagement score door actief sentiment management. Benchmark: 5-10% in eerste jaar, 10-15% na 2 jaar met consistente actie.' },
      { key: 'productivity_factor', label: 'Productiviteit per % engagement', default: 0.5, min: 0.2, max: 1, step: 0.1, unit: '%', tooltip: 'Productiviteitsverbetering per procent engagement stijging. Research toont 0.4-0.6% productiviteitswinst per % engagement verbetering.' },
      { key: 'turnover_rate', label: 'Huidig verloop (%)', default: 12, min: 0, max: 30, step: 1, unit: '%', tooltip: 'Huidig vrijwillig verlooppercentage. Sentiment analyse helpt vroegtijdig signalen van vertrekintentie te detecteren.' },
      { key: 'turnover_reduction', label: 'Verloop reductie (%)', default: 15, min: 0, max: 30, step: 1, unit: '%', tooltip: 'Verwachte reductie in verloop door proactief management van engagement issues. Vroege interventie voorkomt vertrek.' },
      { key: 'cost_per_turnover', label: 'Kosten per vertrek (€)', default: 15000, min: 0, max: 50000, step: 1, unit: '€', tooltip: 'Kosten per vrijwillig vertrek. Inclusief: werving vervanger, onboarding, productiviteitsverlies, kennisoverdracht.' },
    ],
    roiCalculation: (vars) => {
      const productivityGain = vars.employees * vars.avg_salary * (vars.engagement_improvement / 100) * (vars.productivity_factor / 100);
      const currentTurnover = vars.employees * (vars.turnover_rate / 100);
      const preventedTurnover = currentTurnover * (vars.turnover_reduction / 100);
      const turnoverSavings = preventedTurnover * vars.cost_per_turnover;
      const savings = productivityGain + turnoverSavings;
      const savedHours = preventedTurnover * 30; // Estimated hours per prevented departure
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Productiviteitswinst', value: `€${Math.round(vars.employees * vars.avg_salary * (vars.engagement_improvement / 100) * (vars.productivity_factor / 100)).toLocaleString()}` },
      { label: 'Voorkomen vertrekken', value: Math.round(vars.employees * (vars.turnover_rate / 100) * (vars.turnover_reduction / 100)) },
      { label: 'Verloop kostenbesparing', value: `€${Math.round(vars.employees * (vars.turnover_rate / 100) * (vars.turnover_reduction / 100) * vars.cost_per_turnover).toLocaleString()}` },
    ],
  },
  {
    id: 9,
    title: 'Learning Recommendation Engine',
    description: 'AI that suggests personalized learning paths based on role, skills, career goals, and learning history.',
    shortDescription: 'AI that suggests personalized learning paths based on role, skills, and career goals.',
    category: 'foundational',
    domain: 'learning',
    domainLabel: 'Learning & Development',
    difficulty: 'medium',
    impact: 'medium',
    implTime: '8w',
    cost: 'Medium Cost',
    costRange: '€12,000 - 30,000',
    skills: 3,
    votes: 34,
    implementationSteps: [
      'Catalog and tag all learning content',
      'Define skill-to-content mappings',
      'Configure recommendation algorithm',
      'Integrate with career development tools',
    ],
    requiredSkills: [
      'L&D strategy',
      'Content curation',
      'LMS expertise',
    ],
    tools: ['EdCast', 'Cornerstone', 'Degreed', 'LinkedIn Learning'],
    hoursSaved: 250,
    roiFormula: 'learners * time_saved_finding_content * hourly_rate + completion_rate_improvement',
    roiVariables: [
      { key: 'learners', label: 'Actieve learners', default: 400, min: 0, max: 5000, step: 1, unit: '', tooltip: 'Aantal medewerkers dat actief gebruik maakt van leerplatform. Typisch 60-80% van totaal personeelsbestand.' },
      { key: 'search_time_hours_year', label: 'Zoektijd content/learner/jaar (uur)', default: 10, min: 0, max: 30, step: 1, unit: 'uur', tooltip: 'Jaarlijkse tijd die learners besteden aan zoeken naar relevante content. Inefficiënte LMS systemen: 15-25 uur, moderne systemen: 5-10 uur.' },
      { key: 'hourly_rate', label: 'Gem. uurtarief medewerker (€)', default: 45, min: 0, max: 100, step: 1, unit: '€', tooltip: 'Gemiddeld uurtarief van medewerkers die leerplatform gebruiken. Zoektijd is verloren productiviteit.' },
      { key: 'time_reduction', label: 'Tijdsbesparing zoeken (%)', default: 70, min: 0, max: 90, step: 1, unit: '%', tooltip: 'Tijdsbesparing door gepersonaliseerde aanbevelingen. AI presenteert direct relevante content in plaats van handmatig zoeken.' },
      { key: 'training_budget', label: 'Trainingsbudget per learner (€)', default: 1500, min: 0, max: 5000, step: 1, unit: '€', tooltip: 'Jaarlijks L&D budget per medewerker. Inclusief externe trainingen, cursussen, conferenties, licenties.' },
      { key: 'completion_improvement', label: 'Verbetering completion rate (%)', default: 25, min: 0, max: 50, step: 1, unit: '%', tooltip: 'Verbetering in training completion door relevantere aanbevelingen. Medewerkers maken trainingen af als content aansluit bij behoeften.' },
    ],
    roiCalculation: (vars) => {
      const searchTimeSavings = vars.learners * vars.search_time_hours_year * (vars.time_reduction / 100) * vars.hourly_rate;
      const budgetEfficiency = vars.learners * vars.training_budget * (vars.completion_improvement / 100) * 0.3; // 30% value from better completion
      const savings = searchTimeSavings + budgetEfficiency;
      const savedHours = vars.learners * vars.search_time_hours_year * (vars.time_reduction / 100);
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Uren zoektijd bespaard', value: Math.round(vars.learners * vars.search_time_hours_year * (vars.time_reduction / 100)) },
      { label: 'Zoektijd besparing', value: `€${Math.round(vars.learners * vars.search_time_hours_year * (vars.time_reduction / 100) * vars.hourly_rate).toLocaleString()}` },
      { label: 'Training ROI verbetering', value: `€${Math.round(vars.learners * vars.training_budget * (vars.completion_improvement / 100) * 0.3).toLocaleString()}` },
    ],
  },
  {
    id: 10,
    title: 'Workforce Planning AI',
    description: 'Predictive models for headcount planning, budget forecasting, and scenario modeling based on business drivers.',
    shortDescription: 'Predictive models for headcount planning and budget forecasting.',
    category: 'strategic',
    domain: 'hr-operations',
    domainLabel: 'HR Operations',
    difficulty: 'high',
    impact: 'high',
    implTime: '16w',
    cost: 'High Cost',
    costRange: '€40,000 - 80,000',
    skills: 5,
    votes: 30,
    implementationSteps: [
      'Connect HR data with business metrics',
      'Build predictive demand models',
      'Create scenario planning dashboards',
      'Integrate with finance planning cycles',
    ],
    requiredSkills: [
      'Workforce planning',
      'Financial modeling',
      'Data science',
      'Business acumen',
      'Strategic HR',
    ],
    tools: ['Anaplan', 'Visier', 'Workday Adaptive', 'ChartHop'],
    hoursSaved: 500,
    roiFormula: 'planning_efficiency + avoided_over_under_hiring * cost_impact',
    roiVariables: [
      { key: 'employees', label: 'Aantal medewerkers', default: 1000, min: 0, max: 20000, step: 1, unit: '', tooltip: 'Totaal personeelsbestand waarvoor workforce planning wordt gedaan. Grootte bepaalt complexiteit en besparingspotentieel.' },
      { key: 'planning_cycles_year', label: 'Planning cycli per jaar', default: 4, min: 0, max: 12, step: 1, unit: '', tooltip: 'Aantal formele workforce planning rondes per jaar. Typisch: jaarlijks (1), per kwartaal (4), of maandelijks (12) voor dynamische organisaties.' },
      { key: 'planners', label: 'Aantal HR planners', default: 5, min: 0, max: 30, step: 1, unit: '', tooltip: 'Aantal FTE betrokken bij workforce planning. Inclusief HR analytics, HRBP, en finance partners.' },
      { key: 'hours_per_cycle', label: 'Uren per planner per cyclus', default: 40, min: 0, max: 100, step: 1, unit: 'uur', tooltip: 'Tijd per planner per planning cyclus. Inclusief: data verzamelen, analyse, scenario modelling, rapportage, afstemming met stakeholders.' },
      { key: 'hourly_rate', label: 'Uurtarief planner (€)', default: 55, min: 0, max: 120, step: 1, unit: '€', tooltip: 'Gemiddeld uurtarief workforce planners. Typisch senior HR/analytics professionals.' },
      { key: 'time_reduction', label: 'Tijdsbesparing (%)', default: 50, min: 0, max: 70, step: 1, unit: '%', tooltip: 'Tijdsbesparing door automatisering van data-analyse en scenario modelling. AI versnelt forecasting significant.' },
      { key: 'hiring_error_cost', label: 'Kosten over/onder-hiring (€)', default: 100000, min: 0, max: 500000, step: 1, unit: '€', tooltip: 'Jaarlijkse kosten van slechte workforce planning. Over-hiring: onnodig salaris. Onder-hiring: gemiste omzet, overwerk, kwaliteitsproblemen.' },
      { key: 'error_reduction', label: 'Vermindering planningsfouten (%)', default: 30, min: 0, max: 50, step: 1, unit: '%', tooltip: 'Verbetering in planning accuraatheid door AI-forecasting. Betere voorspellingen reduceren kostbare planningsfouten.' },
    ],
    roiCalculation: (vars) => {
      const planningHours = vars.planning_cycles_year * vars.planners * vars.hours_per_cycle;
      const timeSavings = planningHours * (vars.time_reduction / 100) * vars.hourly_rate;
      const errorSavings = vars.hiring_error_cost * (vars.error_reduction / 100);
      const savings = timeSavings + errorSavings;
      const savedHours = planningHours * (vars.time_reduction / 100);
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Planning uren/jaar', value: vars.planning_cycles_year * vars.planners * vars.hours_per_cycle },
      { label: 'Tijdsbesparing', value: `€${Math.round(vars.planning_cycles_year * vars.planners * vars.hours_per_cycle * (vars.time_reduction / 100) * vars.hourly_rate).toLocaleString()}` },
      { label: 'Vermeden planningsfouten', value: `€${Math.round(vars.hiring_error_cost * (vars.error_reduction / 100)).toLocaleString()}` },
    ],
  },
  {
    id: 11,
    title: 'Compensation Benchmarking AI',
    description: 'Real-time market compensation analysis with AI-driven recommendations for pay decisions and equity reviews.',
    shortDescription: 'Real-time market compensation analysis with AI-driven pay recommendations.',
    category: 'foundational',
    domain: 'hr-operations',
    domainLabel: 'HR Operations',
    difficulty: 'medium',
    impact: 'medium',
    implTime: '6w',
    cost: 'Medium Cost',
    costRange: '€15,000 - 35,000',
    skills: 3,
    votes: 25,
    implementationSteps: [
      'Connect compensation data sources',
      'Configure market data feeds',
      'Build pay analysis dashboards',
      'Set up automated equity alerts',
    ],
    requiredSkills: [
      'Compensation & benefits expertise',
      'Market data analysis',
      'HRIS administration',
    ],
    tools: ['Payscale', 'Mercer', 'Radford', 'Pave'],
    hoursSaved: 200,
    roiFormula: 'comp_decisions * time_per_decision * hourly_rate + retention_impact',
    roiVariables: [
      { key: 'comp_decisions', label: 'Comp beslissingen per jaar', default: 200, min: 0, max: 2000, step: 1, unit: '', tooltip: 'Aantal compensatiebeslissingen per jaar. Inclusief: nieuwe hires, promoties, jaarlijkse reviews, marktaanpassingen, retentie-interventies.' },
      { key: 'time_per_decision_current', label: 'Huidige tijd per beslissing (uur)', default: 3, min: 0, max: 10, step: 0.5, unit: 'uur', tooltip: 'Tijd per compensatiebeslissing. Inclusief: marktdata opzoeken, interne vergelijking, compliance check, goedkeuringsproces, documentatie.' },
      { key: 'hourly_rate', label: 'Uurtarief comp specialist (€)', default: 60, min: 0, max: 120, step: 1, unit: '€', tooltip: 'Uurtarief compensation & benefits specialist. Typisch senior HR professionals met specifieke expertise.' },
      { key: 'time_reduction', label: 'Tijdsbesparing (%)', default: 60, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Tijdsbesparing door geautomatiseerde benchmarking en real-time marktdata. AI levert direct onderbouwde aanbevelingen.' },
      { key: 'employees', label: 'Aantal medewerkers', default: 500, min: 0, max: 10000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers waarvoor compensatie wordt beheerd.' },
      { key: 'pay_equity_issues', label: 'Pay equity problemen/jaar', default: 10, min: 0, max: 50, step: 1, unit: '', tooltip: 'Aantal pay equity issues dat jaarlijks geïdentificeerd/opgelost moet worden. Risico op claims, vertrek, of reputatieschade.' },
      { key: 'cost_per_issue', label: 'Kosten per equity issue (€)', default: 8000, min: 0, max: 30000, step: 1, unit: '€', tooltip: 'Gemiddelde kosten per pay equity probleem. Inclusief: correcties, juridisch advies, retentie-interventies, eventuele claims.' },
      { key: 'issue_reduction', label: 'Vermindering equity issues (%)', default: 50, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Reductie in pay equity problemen door proactieve AI-monitoring. Systeem signaleert ongelijke beloning voordat het escaleert.' },
    ],
    roiCalculation: (vars) => {
      const timeSavings = vars.comp_decisions * vars.time_per_decision_current * (vars.time_reduction / 100) * vars.hourly_rate;
      const equitySavings = vars.pay_equity_issues * (vars.issue_reduction / 100) * vars.cost_per_issue;
      const savings = timeSavings + equitySavings;
      const savedHours = vars.comp_decisions * vars.time_per_decision_current * (vars.time_reduction / 100);
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Uren bespaard op beslissingen', value: Math.round(vars.comp_decisions * vars.time_per_decision_current * (vars.time_reduction / 100)) },
      { label: 'Tijdsbesparing', value: `€${Math.round(vars.comp_decisions * vars.time_per_decision_current * (vars.time_reduction / 100) * vars.hourly_rate).toLocaleString()}` },
      { label: 'Vermeden equity kosten', value: `€${Math.round(vars.pay_equity_issues * (vars.issue_reduction / 100) * vars.cost_per_issue).toLocaleString()}` },
    ],
  },
  {
    id: 12,
    title: 'Internal Mobility Matching',
    description: 'AI that matches employees to internal opportunities based on skills, interests, and development potential.',
    shortDescription: 'AI that matches employees to internal opportunities based on skills and interests.',
    category: 'strategic',
    domain: 'talent',
    domainLabel: 'Talent Management',
    difficulty: 'medium',
    impact: 'high',
    implTime: '10w',
    cost: 'Medium Cost',
    costRange: '€20,000 - 45,000',
    skills: 4,
    votes: 37,
    implementationSteps: [
      'Build internal talent marketplace platform',
      'Map skills to opportunity requirements',
      'Configure matching algorithm',
      'Launch with manager and employee enablement',
    ],
    requiredSkills: [
      'Talent management',
      'Internal mobility expertise',
      'Change management',
      'Platform administration',
    ],
    tools: ['Gloat', 'Eightfold', 'Fuel50', 'Phenom'],
    hoursSaved: 450,
    roiFormula: 'internal_hires * (external_recruitment_cost - internal_cost) + engagement_benefit',
    roiVariables: [
      { key: 'open_positions_year', label: 'Openstaande posities per jaar', default: 80, min: 0, max: 500, step: 1, unit: '', tooltip: 'Totaal aantal te vullen posities per jaar. Inclusief vervanging, groei en interne mobiliteit.' },
      { key: 'current_internal_fill_rate', label: 'Huidige interne invulling (%)', default: 25, min: 0, max: 50, step: 1, unit: '%', tooltip: 'Huidig percentage vacatures dat intern wordt ingevuld. Benchmark: 20-30% typisch, 40%+ bij mature talent management.' },
      { key: 'target_internal_fill_rate', label: 'Doel interne invulling (%)', default: 45, min: 0, max: 70, step: 1, unit: '%', tooltip: 'Streefpercentage interne invulling na implementatie. Realistisch doel: +15-25% ten opzichte van huidige situatie.' },
      { key: 'external_recruitment_cost', label: 'Externe recruitment kosten (€)', default: 18000, min: 0, max: 50000, step: 1, unit: '€', tooltip: 'Volledige kosten per externe hire. Inclusief: sourcing, advertenties, bureau fees, tijd selectieproces, onboarding.' },
      { key: 'internal_mobility_cost', label: 'Interne mobiliteit kosten (€)', default: 3000, min: 0, max: 10000, step: 1, unit: '€', tooltip: 'Kosten per interne mobiliteit. Typisch: selectieproces, korte onboarding, eventuele training. Significant lager dan externe hire.' },
      { key: 'employees', label: 'Aantal medewerkers', default: 1000, min: 0, max: 20000, step: 1, unit: '', tooltip: 'Totaal aantal medewerkers in de interne talent pool.' },
      { key: 'engagement_value_per_employee', label: 'Engagement waarde/medewerker (€)', default: 500, min: 0, max: 2000, step: 1, unit: '€', tooltip: 'Jaarlijkse waarde van verbeterde engagement per medewerker. Interne mogelijkheden verhogen retentie en motivatie.' },
      { key: 'engagement_improvement', label: 'Engagement verbetering (%)', default: 5, min: 0, max: 15, step: 1, unit: '%', tooltip: 'Percentage medewerkers met verbeterde engagement door zichtbare interne carrièremogelijkheden.' },
    ],
    roiCalculation: (vars) => {
      const additionalInternalHires = vars.open_positions_year * ((vars.target_internal_fill_rate - vars.current_internal_fill_rate) / 100);
      const costSavingsPerHire = vars.external_recruitment_cost - vars.internal_mobility_cost;
      const mobilitySavings = additionalInternalHires * costSavingsPerHire;
      const engagementSavings = vars.employees * (vars.engagement_improvement / 100) * vars.engagement_value_per_employee;
      const savings = mobilitySavings + engagementSavings;
      const savedHours = additionalInternalHires * 25; // Estimated hours saved per internal vs external hire
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => [
      { label: 'Extra interne invullingen', value: Math.round(vars.open_positions_year * ((vars.target_internal_fill_rate - vars.current_internal_fill_rate) / 100)) },
      { label: 'Besparing per interne hire', value: `€${(vars.external_recruitment_cost - vars.internal_mobility_cost).toLocaleString()}` },
      { label: 'Engagement waarde', value: `€${Math.round(vars.employees * (vars.engagement_improvement / 100) * vars.engagement_value_per_employee).toLocaleString()}` },
    ],
  },
  {
    id: 13,
    title: 'Reference Checking Voice Chatbot',
    description: 'AI-powered voice chatbot that automates reference checks by calling references and conducting structured interviews. Collects consistent data, transcribes responses, and generates comprehensive reports with sentiment analysis.',
    shortDescription: 'AI voice chatbot that automates reference checking calls with structured interviews and sentiment analysis.',
    category: 'quick-wins',
    domain: 'recruitment',
    domainLabel: 'Recruitment',
    difficulty: 'medium',
    impact: 'high',
    implTime: '6w',
    cost: 'Medium Cost',
    costRange: '€15,000 - 35,000',
    skills: 3,
    votes: 42,
    implementationSteps: [
      'Design reference check interview script and questions',
      'Configure AI voice agent with natural conversation flow',
      'Integrate with ATS for candidate and reference data',
      'Set up transcription and sentiment analysis pipeline',
      'Create automated reporting dashboard',
      'Pilot with subset of hires and iterate based on feedback',
    ],
    requiredSkills: [
      'Recruitment process expertise',
      'Conversation design',
      'Voice AI configuration',
      'ATS integration',
    ],
    tools: ['Checkmate AI', 'Xref', 'SkillSurvey', 'Crosschq', 'Custom Voice AI'],
    hoursSaved: 350,
    roiFormula: 'references_per_year * time_saved_per_reference * hourly_rate + quality_improvement_value',
    roiVariables: [
      { key: 'hires_per_year', label: 'Nieuwe hires per jaar', default: 100, min: 0, max: 1000, step: 1, unit: '', tooltip: 'Aantal nieuwe hires per jaar waarvoor referenties worden gecontroleerd. Typisch alle externe hires op mid-senior niveau.' },
      { key: 'references_per_hire', label: 'Referenties per kandidaat', default: 3, min: 0, max: 5, step: 1, unit: '', tooltip: 'Aantal referenties per kandidaat. Standaard 2-3, voor senior functies vaak 4-5 referenties.' },
      { key: 'time_per_reference_current', label: 'Huidige tijd per referentie (min)', default: 45, min: 0, max: 90, step: 1, unit: 'min', tooltip: 'Totale tijd per referentiecheck. Inclusief: contact leggen, bellen, gesprek voeren, notities maken, rapport schrijven. Vaak meerdere pogingen nodig.' },
      { key: 'hourly_rate_recruiter', label: 'Uurtarief recruiter (€)', default: 50, min: 0, max: 100, step: 1, unit: '€', tooltip: 'Uurtarief recruiter die referentiechecks uitvoert. Volledig belast inclusief werkgeverslasten.' },
      { key: 'time_reduction', label: 'Tijdsbesparing door AI (%)', default: 85, min: 0, max: 95, step: 1, unit: '%', tooltip: 'Tijdsbesparing door AI voice bot. Bot belt automatisch, voert gestructureerd gesprek, transcribeert en analyseert. Recruiter reviewt alleen output.' },
      { key: 'completion_rate_current', label: 'Huidige completion rate (%)', default: 65, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Huidig percentage referenties dat daadwerkelijk bereikt en afgerond wordt. Veel referenties zijn onbereikbaar of reageren niet.' },
      { key: 'completion_rate_ai', label: 'AI completion rate (%)', default: 90, min: 0, max: 98, step: 1, unit: '%', tooltip: 'Verwachte completion rate met AI. Bots kunnen 24/7 bellen, automatisch herplannen, en zijn persistent maar vriendelijk.' },
      { key: 'bad_hire_cost', label: 'Kosten slechte hire (€)', default: 25000, min: 0, max: 75000, step: 1, unit: '€', tooltip: 'Totale kosten van een verkeerde hire die door betere referentiechecks voorkomen had kunnen worden.' },
      { key: 'bad_hire_prevention', label: 'Voorkomen slechte hires (%)', default: 15, min: 0, max: 30, step: 1, unit: '%', tooltip: 'Percentage mis-hires dat voorkomen wordt door diepgaandere, consistentere referentiechecks met sentiment analyse.' },
    ],
    roiCalculation: (vars) => {
      const totalReferences = vars.hires_per_year * vars.references_per_hire;
      const currentHours = (totalReferences * vars.time_per_reference_current) / 60;
      const savedHours = currentHours * (vars.time_reduction / 100);
      const timeSavings = savedHours * vars.hourly_rate_recruiter;
      
      // Quality improvement from better completion and insights
      const improvedCompletion = (vars.completion_rate_ai - vars.completion_rate_current) / 100;
      const additionalInsights = totalReferences * improvedCompletion * 0.5 * vars.hourly_rate_recruiter; // Value of additional completed references
      
      // Bad hire prevention
      const currentBadHires = vars.hires_per_year * 0.1; // Assume 10% bad hire rate
      const preventedBadHires = currentBadHires * (vars.bad_hire_prevention / 100);
      const qualitySavings = preventedBadHires * vars.bad_hire_cost;
      
      const savings = timeSavings + additionalInsights + qualitySavings;
      return { savedHours: Math.round(savedHours), savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => {
      const totalReferences = vars.hires_per_year * vars.references_per_hire;
      const currentHours = (totalReferences * vars.time_per_reference_current) / 60;
      const savedHours = currentHours * (vars.time_reduction / 100);
      return [
        { label: 'Referenties per jaar', value: totalReferences },
        { label: 'Recruiter uren bespaard', value: Math.round(savedHours) },
        { label: 'Tijdsbesparing', value: `€${Math.round(savedHours * vars.hourly_rate_recruiter).toLocaleString()}` },
        { label: 'Completion rate verbetering', value: `${vars.completion_rate_current}% → ${vars.completion_rate_ai}%` },
        { label: 'Voorkomen slechte hires', value: `${Math.round(vars.hires_per_year * 0.1 * (vars.bad_hire_prevention / 100))} per jaar` },
      ];
    },
  },
  {
    id: 16,
    title: 'Employee Referral AI Platform',
    title_nl: 'AI Medewerker-Referral Platform',
    description: 'AI-powered referral platform that matches open roles to your employees\' networks, sends personalised nudges, and rewards successful referrals automatically. Combines lower cost-per-hire, faster time-to-hire and higher retention into a single talent advantage.',
    description_nl: 'AI-platform dat openstaande rollen matcht aan de netwerken van uw medewerkers, gepersonaliseerde nudges stuurt en succesvolle aanbrengers automatisch beloont. Combineert lagere cost-per-hire, snellere doorlooptijd én hogere retentie tot één strategisch voordeel.',
    shortDescription: 'AI matches open roles to employee networks, drives referrals automatically, lower cost-per-hire and higher retention.',
    shortDescription_nl: 'AI matcht openstaande rollen aan netwerken van medewerkers, drijft referrals automatisch aan, lagere cost-per-hire en hogere retentie.',
    category: 'quick-wins',
    secondaryCategory: 'strategic',
    domain: 'recruitment',
    domainLabel: 'Recruitment',
    difficulty: 'medium',
    impact: 'high',
    implTime: '6w',
    cost: 'Medium Cost',
    costRange: '€15,000 - 40,000',
    skills: 3,
    votes: 0,
    implementationSteps: [
      'Inventariseer huidige hiring kosten (agency fees, ads, ATS-uren) en retentie-cijfers per kanaal',
      'Kies referral platform (Talentry, Real Links, ERIN of HR-suite add-on)',
      'Integreer met ATS en HRIS — sync openstaande vacatures en medewerkersdata',
      'Definieer beloningstructuur (cash, vakantiedagen, charity, gamified points) en interne policy',
      'Train AI op succesvolle hires uit netwerken van medewerkers',
      'Communicatiecampagne intern + pilot met 1 afdeling',
      'Roll-out organisatiebreed met dashboard voor leadership',
    ],
    implementationSteps_nl: [
      'Inventariseer huidige hiring kosten (agency fees, ads, ATS-uren) en retentie-cijfers per kanaal',
      'Kies referral platform (Talentry, Real Links, ERIN of HR-suite add-on)',
      'Integreer met ATS en HRIS — sync openstaande vacatures en medewerkersdata',
      'Definieer beloningstructuur (cash, vakantiedagen, charity, gamified points) en interne policy',
      'Train AI op succesvolle hires uit netwerken van medewerkers',
      'Communicatiecampagne intern + pilot met 1 afdeling',
      'Roll-out organisatiebreed met dashboard voor leadership',
    ],
    requiredSkills: [
      'ATS / HRIS integratie',
      'Employer branding',
      'Change management',
      'Reward design',
    ],
    tools: ['Talentry', 'Real Links', 'ERIN', 'Workable Referrals', 'Boon.AI'],
    hoursSaved: 280,
    roiFormula: '(agency_fee_savings + faster_fill_savings + retention_savings) per jaar',
    roiVariables: [
      { key: 'hires_per_year', label: 'Aantal hires per jaar', default: 50, min: 0, max: 1000, step: 1, unit: '', tooltip: 'Totaal aantal nieuwe medewerkers dat u jaarlijks aantrekt. Inclusief vervanging en groei. Tel ook contractors mee die u doorgaans omzet naar vast.' },
      { key: 'referral_share_percent', label: 'Aandeel hires via referral (%)', default: 35, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Doel-percentage hires dat via referral binnenkomt na implementatie. Industry best-practice: 30-45%. Top performers: 50%+. Pre-AI gemiddelde in EU: 10-20%.' },
      { key: 'avg_cost_per_hire', label: 'Gem. cost-per-hire via agency/ads (€)', default: 6000, min: 0, max: 50000, step: 100, unit: '€', tooltip: 'Volledige cost-per-hire via agency/job-boards/headhunters. Inclusief agency fee (20-30% jaarsalaris), advertising, recruiter-uren, assessments. Senior rollen: €8k-25k, mid-level: €4k-8k, junior: €1.5k-3k.' },
      { key: 'referral_cost_per_hire', label: 'Cost-per-hire via referral (€)', default: 1500, min: 0, max: 10000, step: 50, unit: '€', tooltip: 'Inclusief referral bonus + platform-kost per hire. Marktstandaard: 50-70% lager dan agency. Bonus per geslaagde referral: €500-2500 afhankelijk van rol.' },
      { key: 'time_to_hire_days_current', label: 'Time-to-hire huidig (dagen)', default: 45, min: 5, max: 180, step: 1, unit: 'd', tooltip: 'Gemiddelde dagen tussen vacature-opening en getekend contract. Belgisch gemiddelde 2025: 35-50 dagen. Knelpunt-rollen (tech, healthcare): 60-90 dagen.' },
      { key: 'time_to_hire_days_referral', label: 'Time-to-hire via referral (dagen)', default: 25, min: 5, max: 120, step: 1, unit: 'd', tooltip: 'Referrals worden gemiddeld 55% sneller aangenomen (LinkedIn data). Reden: pre-screened, sterkere cultuur-fit, kortere interview-rondes.' },
      { key: 'productivity_cost_per_day', label: 'Productiviteitsverlies / open dag (€)', default: 350, min: 0, max: 3000, step: 50, unit: '€/d', tooltip: 'Opportunity-cost per dag dat een vacature openstaat. Bereken: dagloon × 1.5-2× (overwork collega\'s, gemiste targets, projecten vertraagd). Senior rollen veel hoger.' },
      { key: 'retention_lift_percent', label: 'Retentie-lift referral vs avg (%)', default: 25, min: 0, max: 60, step: 1, unit: '%', tooltip: 'Hogere retentie van referral-hires versus normaal kanaal. SHRM data: referrals blijven 70% langer na 1 jaar, 45% na 3 jaar. Conservatief default: 25%.' },
      { key: 'turnover_replacement_cost', label: 'Vervangingskost per vertrek (€)', default: 12000, min: 0, max: 200000, step: 500, unit: '€', tooltip: 'Volledige kost om iemand te vervangen: recruitment + onboarding-uren + ramp-up tijd + lost productivity. Belgisch gemiddelde: 50-200% van jaarsalaris.' },
    ],
    roiCalculation: (vars) => {
      const referralHires = vars.hires_per_year * (vars.referral_share_percent / 100);
      // 1. Direct sourcing savings: agency fees avoided on referral hires
      const sourcingSavings = referralHires * (vars.avg_cost_per_hire - vars.referral_cost_per_hire);
      // 2. Faster fill savings: days saved × productivity-cost × all hires (not only referrals — faster pipeline lifts avg)
      const daysFaster = Math.max(0, vars.time_to_hire_days_current - vars.time_to_hire_days_referral);
      const fasterFillSavings = referralHires * daysFaster * vars.productivity_cost_per_day;
      // 3. Retention savings: fewer first-year departures among referral hires
      // Assume 18% baseline first-year turnover; lift reduces that by retention_lift_percent
      const baselineDepartures = referralHires * 0.18;
      const departuresPrevented = baselineDepartures * (vars.retention_lift_percent / 100);
      const retentionSavings = departuresPrevented * vars.turnover_replacement_cost;
      const savings = sourcingSavings + fasterFillSavings + retentionSavings;
      // Hours saved estimation: 8h per agency-replaced hire (recruiter + intake calls)
      //   + 1.5h × days-faster per referral (faster pipeline = less rework)
      const savedHours = Math.round(referralHires * 8 + referralHires * daysFaster * 0.4);
      return { savedHours, savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => {
      const referralHires = vars.hires_per_year * (vars.referral_share_percent / 100);
      const daysFaster = Math.max(0, vars.time_to_hire_days_current - vars.time_to_hire_days_referral);
      const sourcingSavings = referralHires * (vars.avg_cost_per_hire - vars.referral_cost_per_hire);
      const fasterFillSavings = referralHires * daysFaster * vars.productivity_cost_per_day;
      const baselineDepartures = referralHires * 0.18;
      const departuresPrevented = baselineDepartures * (vars.retention_lift_percent / 100);
      const retentionSavings = departuresPrevented * vars.turnover_replacement_cost;
      return [
        { label: 'Hires via referral', value: Math.round(referralHires) },
        { label: 'Besparing sourcing-kosten', value: `€${Math.round(sourcingSavings).toLocaleString()}` },
        { label: 'Dagen sneller per vacature', value: daysFaster },
        { label: 'Faster-fill besparing', value: `€${Math.round(fasterFillSavings).toLocaleString()}` },
        { label: 'Voorkomen vertrekken', value: `${Math.round(departuresPrevented * 10) / 10} / jaar` },
        { label: 'Retentie-besparing', value: `€${Math.round(retentionSavings).toLocaleString()}` },
      ];
    },
  },
  {
    id: 17,
    title: 'Candidate Warming AI Agent',
    title_nl: 'AI Candidate Warming Agent',
    description: 'AI agent that periodically reaches out to candidates in your ATS to refresh their profile data (new roles, skills, availability), keeping your talent pool sourcing-ready and dramatically cutting time-to-fill from internal pipeline.',
    description_nl: 'AI agent die kandidaten in uw ATS op regelmatige tijdstippen contacteert om hun profiel actueel te houden (nieuwe rollen, skills, beschikbaarheid). Houdt uw talent pool sourcing-klaar en verkort time-to-fill drastisch via eigen pijplijn.',
    shortDescription: 'AI agent periodically refreshes candidate profiles in your ATS to keep your talent pool sourcing-ready.',
    shortDescription_nl: 'AI agent ververst kandidaatprofielen in uw ATS automatisch om uw talent pool sourcing-klaar te houden.',
    category: 'strategic',
    domain: 'recruitment',
    domainLabel: 'Recruitment',
    difficulty: 'medium',
    impact: 'high',
    implTime: '8w',
    cost: 'Medium Cost',
    costRange: '€20,000 - 50,000',
    skills: 4,
    votes: 0,
    implementationSteps: [
      'Audit huidige ATS-database: aantal kandidaten, laatste contact-datum, data-velden in scope',
      'Definieer warming-frequentie per segment (silver/gold/platinum talent tiers)',
      'Schrijf gesprekssjablonen (email + WhatsApp + voice) in samenwerking met employer branding',
      'Selecteer AI-agent platform met multichannel-ondersteuning en EU-GDPR compliance',
      'Integreer met ATS via API (Workday, SmartRecruiters, BambooHR, etc.)',
      'Pilot 3 maanden met 1 kandidaatsegment, meet response-rate en data-update kwaliteit',
      'Roll-out + dashboards voor sourcers (welke profielen zijn actueel en hire-ready)',
    ],
    implementationSteps_nl: [
      'Audit huidige ATS-database: aantal kandidaten, laatste contact-datum, data-velden in scope',
      'Definieer warming-frequentie per segment (silver/gold/platinum talent tiers)',
      'Schrijf gesprekssjablonen (email + WhatsApp + voice) in samenwerking met employer branding',
      'Selecteer AI-agent platform met multichannel-ondersteuning en EU-GDPR compliance',
      'Integreer met ATS via API (Workday, SmartRecruiters, BambooHR, etc.)',
      'Pilot 3 maanden met 1 kandidaatsegment, meet response-rate en data-update kwaliteit',
      'Roll-out + dashboards voor sourcers (welke profielen zijn actueel en hire-ready)',
    ],
    requiredSkills: [
      'AI agent design',
      'ATS API integratie',
      'GDPR compliance',
      'Conversation design',
      'Talent operations',
    ],
    tools: ['Eightfold AI', 'Beamery', 'hireEZ', 'Phenom People', 'Gem'],
    hoursSaved: 480,
    roiFormula: '(direct_hires_from_pool × cost_avoided) + (stale_data_prevented × hire_value_recovered)',
    roiVariables: [
      { key: 'ats_database_size', label: 'Kandidaten in ATS', default: 5000, min: 0, max: 500000, step: 100, unit: '', tooltip: 'Totaal aantal kandidaten momenteel in uw ATS. Veel organisaties zitten op 10k-50k waarvan slechts 30-40% sourcing-bruikbaar is wegens stale data.' },
      { key: 'hires_per_year', label: 'Aantal hires per jaar', default: 50, min: 0, max: 1000, step: 1, unit: '', tooltip: 'Aantal nieuwe medewerkers dat u jaarlijks aantrekt — bepaalt hoe vaak de talent pool aangesproken kan worden.' },
      { key: 'current_pool_hire_share', label: 'Hires uit ATS-pool nu (%)', default: 8, min: 0, max: 60, step: 1, unit: '%', tooltip: 'Percentage hires dat u nu uit uw eigen ATS-pool haalt (geen agency/ads). Vóór AI-warming meestal 5-15%. Best-in-class: 35%+.' },
      { key: 'target_pool_hire_share', label: 'Hires uit ATS-pool na AI (%)', default: 30, min: 0, max: 70, step: 1, unit: '%', tooltip: 'Doel-percentage na implementatie van AI-warming. Realistisch: 25-35% na 12 maanden. Top-performers: 45%+. Hoe hoger uw pool kwaliteit, hoe hoger dit cijfer kan.' },
      { key: 'avg_cost_per_hire_external', label: 'Cost-per-hire via extern (€)', default: 6000, min: 0, max: 50000, step: 100, unit: '€', tooltip: 'Wat het u kost om iemand extern aan te trekken (agency, ads, headhunters). Hires uit eigen pool vermijden deze kost grotendeels.' },
      { key: 'data_decay_percent_per_year', label: 'Profiel-decay per jaar (%)', default: 40, min: 0, max: 80, step: 1, unit: '%', tooltip: 'Percentage profielen dat per jaar onbruikbaar wordt zonder warming (verkeerde rol, email, beschikbaarheid). Industry benchmark: 35-50%/jaar. Reden: job-mobility van 20%+ per jaar in EU.' },
      { key: 'warming_response_rate', label: 'Respons-rate op AI-outreach (%)', default: 35, min: 0, max: 90, step: 1, unit: '%', tooltip: 'Percentage kandidaten dat reageert op de AI-warming nudge (email/WhatsApp). Marktgemiddelde voor goed-getrainde AI-agents: 25-40%. Personalisatie en timing maken het verschil.' },
      { key: 'sourcer_hours_saved_per_hire', label: 'Sourcer-uren bespaard per pool-hire', default: 6, min: 0, max: 40, step: 1, unit: 'h', tooltip: 'Uren die een sourcer normaal kwijt is aan zoeken/screenen voor een externe hire. Met een actuele pool valt deze stap grotendeels weg.' },
      { key: 'sourcer_hourly_rate', label: 'Uurtarief sourcer (€)', default: 50, min: 0, max: 150, step: 1, unit: '€', tooltip: 'Volledig belast uurtarief sourcer. Senior sourcer: €55-75; medior: €40-55; junior: €25-40.' },
    ],
    roiCalculation: (vars) => {
      const lift = Math.max(0, vars.target_pool_hire_share - vars.current_pool_hire_share) / 100;
      const additionalPoolHires = vars.hires_per_year * lift;
      // 1. Direct sourcing savings: external cost avoided on pool-hires
      const sourcingSavings = additionalPoolHires * vars.avg_cost_per_hire_external * 0.7; // 70% of external cost truly avoided (some intake still needed)
      // 2. Sourcer time saved
      const sourcerSavings = additionalPoolHires * vars.sourcer_hours_saved_per_hire * vars.sourcer_hourly_rate;
      // 3. Stale-data prevention value: each refreshed profile that becomes hire-able is a future asset
      // Approximation: profiles kept fresh by AI = ats_database_size × (response_rate / 100)
      // Of those, conservatively 0.5% become an actual hire per year that wouldn't have happened
      const profilesKeptFresh = vars.ats_database_size * (vars.warming_response_rate / 100);
      const hiresFromRescuedData = profilesKeptFresh * 0.005;
      const dataValueRecovered = hiresFromRescuedData * vars.avg_cost_per_hire_external * 0.5;
      const savings = sourcingSavings + sourcerSavings + dataValueRecovered;
      const savedHours = Math.round(
        additionalPoolHires * vars.sourcer_hours_saved_per_hire
        + hiresFromRescuedData * vars.sourcer_hours_saved_per_hire,
      );
      return { savedHours, savings: Math.round(savings) };
    },
    roiBreakdown: (vars) => {
      const lift = Math.max(0, vars.target_pool_hire_share - vars.current_pool_hire_share) / 100;
      const additionalPoolHires = vars.hires_per_year * lift;
      const profilesKeptFresh = vars.ats_database_size * (vars.warming_response_rate / 100);
      const hiresFromRescuedData = profilesKeptFresh * 0.005;
      return [
        { label: 'Extra hires via eigen pool', value: Math.round(additionalPoolHires * 10) / 10 },
        { label: 'Profielen actueel gehouden', value: Math.round(profilesKeptFresh).toLocaleString() },
        { label: 'Hires "gered" uit verouderde data', value: Math.round(hiresFromRescuedData * 10) / 10 },
        { label: 'Externe cost-per-hire vermeden', value: `€${Math.round(additionalPoolHires * vars.avg_cost_per_hire_external * 0.7).toLocaleString()}` },
        { label: 'Sourcer-tijd bespaard', value: `${Math.round(additionalPoolHires * vars.sourcer_hours_saved_per_hire)} uren` },
        { label: 'Profile-decay vermeden', value: `${vars.data_decay_percent_per_year}% → ${Math.round(vars.data_decay_percent_per_year * 0.4)}%` },
      ];
    },
  },
];

export const useCases = useCasesDetailed.map(uc => ({
  id: uc.id,
  title: uc.title,
  description: uc.shortDescription,
  category: uc.category,
  secondaryCategory: uc.secondaryCategory,
  domain: uc.domainLabel,
  difficulty: uc.difficulty,
  impact: uc.impact,
  impl_time: uc.implTime,
  cost: uc.cost,
  skills: uc.skills,
  votes: uc.votes,
}));

export const assessmentQuestions = [
  {
    id: 1,
    dimension: 'Adoption',
    question: 'To what extent does your HR team currently use AI tools?',
    options: [
      { value: 1, label: 'No AI tools in use' },
      { value: 2, label: 'Experimenting with 1-2 tools' },
      { value: 3, label: 'Regular use of several AI tools' },
      { value: 4, label: 'AI integrated across most HR processes' },
    ],
  },
  {
    id: 2,
    dimension: 'Adoption',
    question: 'How familiar is your HR team with AI capabilities?',
    options: [
      { value: 1, label: 'Little to no knowledge' },
      { value: 2, label: 'Basic understanding' },
      { value: 3, label: 'Good understanding with some hands-on experience' },
      { value: 4, label: 'Expert knowledge and practical experience' },
    ],
  },
  {
    id: 3,
    dimension: 'Processes',
    question: 'How standardized are your HR processes?',
    options: [
      { value: 1, label: 'Mostly ad-hoc and inconsistent' },
      { value: 2, label: 'Some documented processes' },
      { value: 3, label: 'Most processes are standardized' },
      { value: 4, label: 'Fully standardized and optimized' },
    ],
  },
  {
    id: 4,
    dimension: 'Processes',
    question: 'How ready are your processes for automation?',
    options: [
      { value: 1, label: 'Not ready - too complex or undefined' },
      { value: 2, label: 'Some processes could be automated' },
      { value: 3, label: 'Many processes are automation-ready' },
      { value: 4, label: 'Processes designed with automation in mind' },
    ],
  },
  {
    id: 5,
    dimension: 'Data & Governance',
    question: 'How would you rate your HR data quality?',
    options: [
      { value: 1, label: 'Poor - inconsistent and incomplete' },
      { value: 2, label: 'Fair - some data quality issues' },
      { value: 3, label: 'Good - mostly clean and structured' },
      { value: 4, label: 'Excellent - high quality and well-maintained' },
    ],
  },
  {
    id: 6,
    dimension: 'Data & Governance',
    question: 'Do you have data governance policies for AI use?',
    options: [
      { value: 1, label: 'No policies in place' },
      { value: 2, label: 'Basic policies being developed' },
      { value: 3, label: 'Comprehensive policies implemented' },
      { value: 4, label: 'Advanced governance with regular audits' },
    ],
  },
  {
    id: 7,
    dimension: 'Skills & Change',
    question: 'How change-ready is your HR organization?',
    options: [
      { value: 1, label: 'Resistant to change' },
      { value: 2, label: 'Open but cautious' },
      { value: 3, label: 'Actively embracing change' },
      { value: 4, label: 'Change champions driving innovation' },
    ],
  },
  {
    id: 8,
    dimension: 'Skills & Change',
    question: 'What AI/digital skills training is available to HR?',
    options: [
      { value: 1, label: 'No training available' },
      { value: 2, label: 'Basic awareness training' },
      { value: 3, label: 'Regular skills development programs' },
      { value: 4, label: 'Comprehensive AI upskilling curriculum' },
    ],
  },
];

export const dimensions = [
  {
    id: 'adoption',
    title: 'Adoption',
    description: 'To what extent do you already use AI in HR processes?',
    icon: 'Cpu',
  },
  {
    id: 'processes',
    title: 'Processes',
    description: 'How mature are your processes for AI integration?',
    icon: 'Settings',
  },
  {
    id: 'data',
    title: 'Data & Governance',
    description: 'How is your data quality and compliance?',
    icon: 'Database',
  },
  {
    id: 'skills',
    title: 'Skills & Change',
    description: 'Is your team ready for the AI transition?',
    icon: 'Users',
  },
  {
    id: 'strategy',
    title: 'Strategy & Vision',
    description: 'Is there a clear AI vision and roadmap for HR?',
    icon: 'Compass',
  },
  {
    id: 'ethics',
    title: 'Ethics & Trust',
    description: 'How do you ensure responsible and fair AI use?',
    icon: 'Shield',
  },
];

export const categories = [
  { value: 'all', label: 'All Categories' },
  { value: 'quick-wins', label: 'Quick Wins' },
  { value: 'foundational', label: 'Foundational' },
  { value: 'strategic', label: 'Strategic' },
];

export const domains = [
  { value: 'all', label: 'All domains' },
  { value: 'recruitment', label: 'Recruitment' },
  { value: 'learning', label: 'Learning & Development' },
  { value: 'talent', label: 'Talent Management' },
  { value: 'performance', label: 'Performance' },
  { value: 'wellbeing', label: 'Wellbeing' },
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'hr-operations', label: 'HR Operations' },
];

export const difficulties = [
  { value: 'all', label: 'All levels' },
  { value: 'low', label: 'Low (Quick Win)' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High (Strategic)' },
];

export const impacts = [
  { value: 'all', label: 'All impact' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const sortOptions = [
  { value: 'popular', label: 'Most Popular' },
  { value: 'impact', label: 'Highest Impact' },
  { value: 'quick', label: 'Quick Wins First' },
];

export const stats = {
  assessments: '250+',
  rating: '4.8/5.0',
  implementRate: '80%',
  weeklyAssessments: 37,
};

export const workshopAgenda = [
  { time: '09:00 - 09:30', title: 'AI in HR: State of the Art', titleNL: 'AI in HR: De Stand van Zaken', description: 'Overview of AI possibilities, industry trends and quick wins', descriptionNL: 'Overzicht van AI-mogelijkheden, trends in de sector en quick wins' },
  { time: '09:30 - 10:00', title: 'Use Case Selection & Prioritization', titleNL: 'Use Case Selectie & Prioritering', description: 'Selecting 1-2 concrete use cases relevant for your organization', descriptionNL: 'Selecteren van 1-2 concrete use cases relevant voor uw organisatie' },
  { time: '10:00 - 11:30', title: 'Hands-on Building Session', titleNL: 'Praktische Bouwsessie', description: 'Building working AI prototypes with expert guidance (includes break)', descriptionNL: 'Bouwen van werkende AI-prototypes met deskundige begeleiding (inclusief pauze)' },
  { time: '11:30 - 12:15', title: 'Testing & Refinement', titleNL: 'Testen & Verfijnen', description: 'Testing with real data, refining models and optimizing results', descriptionNL: 'Testen met echte data, verfijnen van modellen en optimaliseren van resultaten' },
  { time: '12:15 - 12:45', title: 'AI Governance & Ethics', titleNL: 'AI Governance & Ethiek', description: 'Setting up bias monitoring, compliance frameworks and ethical guidelines', descriptionNL: 'Opzetten van bias-monitoring, compliance-kaders en ethische richtlijnen' },
  { time: '12:45 - 13:00', title: 'Implementation Roadmap', titleNL: 'Implementatie Roadmap', description: 'From prototype to production: concrete next steps and timeline', descriptionNL: 'Van prototype naar productie: concrete vervolgstappen en tijdlijn' },
];

export const workshopLearnings = [
  { en: 'How to deploy AI for concrete HR challenges (recruitment, learning, talent)', nl: 'Hoe AI in te zetten voor concrete HR-uitdagingen (werving, leren, talent)' },
  { en: 'Building a working AI prototype without programming knowledge', nl: 'Een werkend AI-prototype bouwen zonder programmeerkennis' },
  { en: 'Best practices for AI governance and ethical AI in HR', nl: 'Best practices voor AI-governance en ethische AI in HR' },
  { en: 'ROI calculation and business case for AI in HR', nl: 'ROI-berekening en business case voor AI in HR' },
];


// Gartner Hype Cycle Phases with default use case positioning
export const gartnerHypePhases = [
  { id: 'innovation_trigger', label: 'Innovation Trigger', labelNL: 'Innovatie Trigger', position: 10 },
  { id: 'peak_expectations', label: 'Peak of Inflated Expectations', labelNL: 'Piek van Verwachtingen', position: 30 },
  { id: 'trough_disillusionment', label: 'Trough of Disillusionment', labelNL: 'Dal van Desillusie', position: 50 },
  { id: 'slope_enlightenment', label: 'Slope of Enlightenment', labelNL: 'Helling van Verlichting', position: 70 },
  { id: 'plateau_productivity', label: 'Plateau of Productivity', labelNL: 'Plateau van Productiviteit', position: 90 },
];

// Default Gartner Hype Cycle positioning for use cases
export const defaultGartnerPositions = {
  'AI-Powered CV Screening': { phase: 'slope_enlightenment', maturityYears: '2-5 years' },
  'HR FAQ Chatbot': { phase: 'plateau_productivity', maturityYears: '< 2 years' },
  'Onboarding Chatbot': { phase: 'plateau_productivity', maturityYears: '< 2 years' },
  'Predictive Attrition Analysis': { phase: 'trough_disillusionment', maturityYears: '5-10 years' },
  'Automated Onboarding Journey': { phase: 'slope_enlightenment', maturityYears: '2-5 years' },
  'Skills Gap Analysis': { phase: 'slope_enlightenment', maturityYears: '2-5 years' },
  'Performance Review Summarizer': { phase: 'peak_expectations', maturityYears: '5-10 years' },
  'Interview Intelligence': { phase: 'peak_expectations', maturityYears: '5-10 years' },
  'Employee Sentiment Analysis': { phase: 'trough_disillusionment', maturityYears: '2-5 years' },
  'Learning Recommendation Engine': { phase: 'slope_enlightenment', maturityYears: '2-5 years' },
  'Workforce Planning AI': { phase: 'innovation_trigger', maturityYears: '> 10 years' },
  'Compensation Benchmarking AI': { phase: 'slope_enlightenment', maturityYears: '2-5 years' },
  'Internal Mobility Matching': { phase: 'peak_expectations', maturityYears: '5-10 years' },
  'Reference Checking Voice Chatbot': { phase: 'innovation_trigger', maturityYears: '5-10 years' },
};

